<template>
<b-tab lazy title-item-class="mr-1" :title-link-class="{'bg-danger': hasErrors, 'bg-warning': isDirty}">
    <template slot="title">
        <i v-if="isDirty || hasErrors" class="fa-solid fa-circle-exclamation" :class="{ 'fa-circle-exclamation text-white': hasErrors, 'fa-cloud-arrow-up text-black': isDirty}"></i> Measurements
    </template>
    <measurements-base button-top small fixed :callback="createPatientAdminMeasurements" />
</b-tab>
</template>
<script>
import TabExtension from "../TabExtension"
import MeasurementsBase from "@/core/components/health/measurements/MeasurementsBase"
import { mapActions } from "vuex"

export default TabExtension.extend({
    name: "measurements",
    components: {
        'measurements-base': MeasurementsBase
    },
    methods: {
        ...mapActions('health', ['createPatientAdminMeasurements']),
    }
})
</script>